import { Component, Input, OnInit, OnChanges, Inject } from '@angular/core';
import { Meta } from '../../angular2-meta';
import { IVisualState } from '../visual/visual.reducer';

@Component({
  selector: 'nns-audio-attachment',
  template: `
    <nns-audio-player
      *ngIf="isBrowser"
      [attachment]="attachment"
    >
    </nns-audio-player>
  `,
  styles: []
})
export class AudioAttachmentComponent implements OnInit, OnChanges {
  @Input() attachment;
  @Input() share;
  @Input() note;
  @Input() visual:IVisualState;

  constructor(
    public _meta: Meta,
    @Inject('isBrowser') public isBrowser: boolean
  ) { }

  ngOnChanges() {
    this.setMeta();
  }

  ngOnInit() {
    this.setMeta();
  }

  setMeta() {
    this._meta.setMetaForAttachment(this.share, this.note, this.attachment);
  }
}
